import React from 'react'
import { Routes, Route } from 'react-router-dom'

// Layouts
import PublicLayout from './components/layouts/PublicLayout'
import MemberLayout from './components/layouts/MemberLayout'

// Public pages
import HomePage from './pages/public/HomePage/HomePage'
import ContactPage from './pages/public/ContactPage/ContactPage'
import RankingPage from './pages/public/RankingPage/RankingPage'
import LoginPage from './pages/public/LoginPage/LoginPage'
import PokerTourPage from './pages/public/HomePage/register/RegisterPokerTour'

// Member pages
import DashboardPage from './pages/member/DashboardPage/DashboardPage'
import ProfilePage from './pages/member/ProfilePage/ProfilePage'
import AdminMembersPage from './pages/member/AdminMembersPage/AdminMembersPage'

// Components
import PrivateRoute from './components/PrivateRoute/PrivateRoute'
import ClubPage from './pages/public/ClubPage/ClubPage'

function App() {
  return (
    <Routes>
      {/* Zone publique */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/club" element={<ClubPage />} />
        <Route path="/classement" element={<RankingPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/pokertour" element={<PokerTourPage />} />
      </Route>

      {/* Zone membre (protégée) */}
      <Route element={<PrivateRoute><MemberLayout /></PrivateRoute>}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Route>

      {/* Zone admin (protégée + admin) */}
      <Route element={<PrivateRoute adminOnly><MemberLayout /></PrivateRoute>}>
        <Route path="/admin/members" element={<AdminMembersPage />} />
      </Route>
    </Routes>
  )
}

export default App
